<template>
  <div class="dialog-view">
    <div class="dialog">
      <h2>确定要退出登录吗？</h2>
      <h3>退出登录将导致个人中心无法使用</h3>

      <div class="btns">
        <button @click="logout">确定</button>
        <button class="cancel" @click="close">取消</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    logout() {
        this.$emit('logout')
    },
    close() {
        this.$emit('close')
    },
  },
};
</script>
<style scoped lang='less'>
.dialog-view {
  width: 100%;
  height: 100vh;
  // 半透明背景
  background: rgba(0, 0, 0, 0.5);

  position: fixed;
  top: 0;
  z-index: 12;
  left: 0;
  .dialog {
    width: 300px;
    height: 200px;
    background: #fff;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 60px 20px 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    h2,
    h3 {
      text-align: center;
    }
    .btns {
      display: flex;
      justify-content: center;
      margin-top: 120px;
      .cancel {
        background: gray !important;
      }
      button {
        padding: 5px 10px;
        margin: 0 10px;
        border: none;
        border-radius: 5px;
        background: #409eff;
        color: #fff;
        cursor: pointer;
        &:hover {
          background: #66b1ff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/logout-dialog.vue